import React, { Component } from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import {
  APIURL,
  IMAGE_THUMB_URL,
  IMAGE_NOPHOTO_URL,
  PORT,
  IMAGE_FULL_URL,
  IMAGE_UPLOAD_ERROR
} from '../../../config/config'

class CarEditAlbum extends Component {

  constructor (props){
    super(props)

    this.state = {
      user: {},
      front_car: IMAGE_NOPHOTO_URL,
      front_right: IMAGE_NOPHOTO_URL,
      front_left: IMAGE_NOPHOTO_URL,
      side_car_left: IMAGE_NOPHOTO_URL,
      side_car_right: IMAGE_NOPHOTO_URL,
      back_straight: IMAGE_NOPHOTO_URL,
      condition_in_car: IMAGE_NOPHOTO_URL,
      engine_car: IMAGE_NOPHOTO_URL,
      console_car: IMAGE_NOPHOTO_URL,
      plate_car: IMAGE_NOPHOTO_URL,
      other_car: IMAGE_NOPHOTO_URL,
      console: IMAGE_NOPHOTO_URL,
      gear: IMAGE_NOPHOTO_URL,
      audio_equipment: IMAGE_NOPHOTO_URL,
      dial: IMAGE_NOPHOTO_URL,
      //
      front_car_full: IMAGE_NOPHOTO_URL,
      front_right_full: IMAGE_NOPHOTO_URL,
      front_left_full: IMAGE_NOPHOTO_URL,
      side_car_left_full: IMAGE_NOPHOTO_URL,
      side_car_right_full: IMAGE_NOPHOTO_URL,
      back_straight_full: IMAGE_NOPHOTO_URL,
      condition_in_car_full: IMAGE_NOPHOTO_URL,
      engine_car_full: IMAGE_NOPHOTO_URL,
      console_car_full: IMAGE_NOPHOTO_URL,
      plate_car_full: IMAGE_NOPHOTO_URL,
      other_car_full: IMAGE_NOPHOTO_URL,
      console_full: IMAGE_NOPHOTO_URL,
      gear_full: IMAGE_NOPHOTO_URL,
      audio_equipment_full: IMAGE_NOPHOTO_URL,
      dial_full: IMAGE_NOPHOTO_URL,

      //
      front_car2: IMAGE_NOPHOTO_URL,
      front_right2: IMAGE_NOPHOTO_URL,
      front_left2: IMAGE_NOPHOTO_URL,
      side_car_left2: IMAGE_NOPHOTO_URL,
      side_car_right2: IMAGE_NOPHOTO_URL,
      back_straight2: IMAGE_NOPHOTO_URL,
      condition_in_car2: IMAGE_NOPHOTO_URL,
      engine_car2: IMAGE_NOPHOTO_URL,
      console_car2: IMAGE_NOPHOTO_URL,
      plate_car2: IMAGE_NOPHOTO_URL,
      other_car2: IMAGE_NOPHOTO_URL,
      //
      front_car_id2: '0',
      front_right_id2: '0',
      front_left_id2: '0',
      side_car_left_id2: '0',
      side_car_right_id2: '0',
      back_straight_id2: '0',
      console_car_id2: '0',
      condition_in_car_id2: '0',
      engine_car_id2: '0',
      plate_car_id2: '0',
      other_car_id2: '0',
      //
      photos: [],
      front_car_id: 0,
      front_right_id: 0,
      front_left_id: 0,
      side_car_left_id: 0,
      side_car_right_id: 0,
      back_straight_id: 0,
      condition_in_car_id: 0,
      engine_car_id: 0,
      console_car_id: 0,
      plate_car_id: 0,
      other_car_id: 0,
      console_id: 0,
      gear_id: 0,
      audio_equipment_id: 0,
      dial_id: 0,
    }

    this.handleUploadFile = this.handleUploadFile.bind(this);
    this.handleUploadFile2 = this.handleUploadFile2.bind(this);
    this.saveCarImage = this.saveCarImage.bind(this);

  }

  componentWillMount() {
    this.setState({
      user: JSON.parse(this.props.user)
    });
  }
  componentDidMount() {
     //var upload_code = this.props.car.car_upload_code
     //this.getCarUploadPhoto(componentDidMountupload_code);
     // console.log("componentDidMount="+this.props.photos)
      this.getCarUploadPhoto(this.props.upload_code)
  }

  getCarUploadPhoto(upload_code){

    //alert(APIURL + '/car_upload/'+upload_code)
    axios.get(APIURL + '/car_upload/'+upload_code)
      .then(res => {
        this.setState({photos: res.data},()=>{
          this.setCarAlbum();
        })
      }).catch(error => {
      alert("error="+error)
      this.setState({photos: []})
    })
  }

  setCarAlbum(){

    // eslint-disable-next-line
    this.state.photos.map(photo => {

      // console.log(photo)

      if (photo.car_upload_position === 'front_car') {
        this.setState({
          front_car: IMAGE_THUMB_URL+photo.car_upload_filename,
          front_car_full: IMAGE_FULL_URL+photo.car_upload_filename,
          front_car_id: photo.car_upload_id
        })
      }
      else if(photo.car_upload_position === 'front_right'){
        this.setState({
           front_right: IMAGE_THUMB_URL+photo.car_upload_filename,
           front_right_full: IMAGE_FULL_URL+photo.car_upload_filename,
           front_right_id: photo.car_upload_id
        })
      }
      else if(photo.car_upload_position === 'front_left'){
        this.setState({
          front_left: IMAGE_THUMB_URL+photo.car_upload_filename,
          front_left_full: IMAGE_FULL_URL+photo.car_upload_filename,
          front_left_id: photo.car_upload_id
        })
      }
      else if(photo.car_upload_position === 'side_car_left'){
        this.setState({
          side_car_left: IMAGE_THUMB_URL+photo.car_upload_filename,
          side_car_left_full: IMAGE_FULL_URL+photo.car_upload_filename,
          side_car_left_id: photo.car_upload_id
        })
      }
      else if(photo.car_upload_position === 'side_car_right'){
        this.setState({
          side_car_right: IMAGE_THUMB_URL+photo.car_upload_filename,
          side_car_right_full: IMAGE_FULL_URL+photo.car_upload_filename,
          side_car_right_id: photo.car_upload_id
        })
      }
      else if(photo.car_upload_position === 'back_straight'){
        this.setState({
          back_straight: IMAGE_THUMB_URL+photo.car_upload_filename ,
          back_straight_full: IMAGE_FULL_URL+photo.car_upload_filename ,
          back_straight_id: photo.car_upload_id
        })
      }
      else if(photo.car_upload_position === 'condition_in_car'){
        this.setState({
          condition_in_car: IMAGE_THUMB_URL+photo.car_upload_filename,
          condition_in_car_full: IMAGE_FULL_URL+photo.car_upload_filename,
          condition_in_car_id: photo.car_upload_id
        })
      }
      else if(photo.car_upload_position === 'engine_car'){
        this.setState({
          engine_car: IMAGE_THUMB_URL+photo.car_upload_filename,
          engine_car_full: IMAGE_FULL_URL+photo.car_upload_filename,
          engine_car_id: photo.car_upload_id
        })
      }
      else if(photo.car_upload_position === 'console_car'){
        this.setState({
          console_car: IMAGE_THUMB_URL+photo.car_upload_filename,
          console_car_full: IMAGE_FULL_URL+photo.car_upload_filename,
          console_car_id: photo.car_upload_id
        })
      }
      else if(photo.car_upload_position === 'plate_car'){
        this.setState({
          plate_car: IMAGE_THUMB_URL+photo.car_upload_filename,
          plate_car_full: IMAGE_FULL_URL+photo.car_upload_filename,
          plate_car_id: photo.car_upload_id
        })
      }
      else if(photo.car_upload_position === 'other_car'){
        this.setState({
          other_car: IMAGE_THUMB_URL+photo.car_upload_filename,
          other_car_full: IMAGE_FULL_URL+photo.car_upload_filename,
          other_car_id: photo.car_upload_id
        })
      }
      else if(photo.car_upload_position === 'console'){
        this.setState({
          console: IMAGE_THUMB_URL+photo.car_upload_filename,
          console_full: IMAGE_FULL_URL+photo.car_upload_filename,
          console_id: photo.car_upload_id
        })
      }
      else if(photo.car_upload_position === 'gear'){
        this.setState({
          gear: IMAGE_THUMB_URL+photo.car_upload_filename,
          gear_full: IMAGE_FULL_URL+photo.car_upload_filename,
          gear_id: photo.car_upload_id
        })
      }
      else if(photo.car_upload_position === 'audio_equipment'){
        this.setState({
          audio_equipment: IMAGE_THUMB_URL+photo.car_upload_filename,
          audio_equipment_full: IMAGE_FULL_URL+photo.car_upload_filename,
          audio_equipment_id: photo.car_upload_id
        })
      }
      else if(photo.car_upload_position === 'dial'){
        this.setState({
          dial: IMAGE_THUMB_URL+photo.car_upload_filename,
          dial_full: IMAGE_FULL_URL+photo.car_upload_filename,
          dial_id: photo.car_upload_id
        })
      }

      /// ภาพก่อนแต่ง
      if (photo.car_upload_position === 'front_car2') {
        this.setState({
          front_car2: IMAGE_THUMB_URL+photo.car_upload_filename,
          front_car_id2: photo.car_upload_id
        })
      }
      else if(photo.car_upload_position === 'front_right2'){
        this.setState({
          front_right2: IMAGE_THUMB_URL+photo.car_upload_filename,
          front_right_id2: photo.car_upload_id
        })
      }
      else if(photo.car_upload_position === 'front_left2'){
        this.setState({
          front_left2: IMAGE_THUMB_URL+photo.car_upload_filename,
          front_left_id2: photo.car_upload_id
        })
      }
      else if(photo.car_upload_position === 'side_car_left2'){
        this.setState({
          side_car_left2: IMAGE_THUMB_URL+photo.car_upload_filename,
          side_car_left_id2: photo.car_upload_id
        })
      }
      else if(photo.car_upload_position === 'side_car_right2'){
        this.setState({
          side_car_right2: IMAGE_THUMB_URL+photo.car_upload_filename,
          side_car_right_id2: photo.car_upload_id
        })
      }
      else if(photo.car_upload_position === 'back_straight2'){
        this.setState({
          back_straight2: IMAGE_THUMB_URL+photo.car_upload_filename ,
          back_straight_id2: photo.car_upload_id
        })
      }
      else if(photo.car_upload_position === 'condition_in_car2'){
        this.setState({
          condition_in_car2: IMAGE_THUMB_URL+photo.car_upload_filename,
          condition_in_car_id2: photo.car_upload_id
        })
      }
      else if(photo.car_upload_position === 'engine_car2'){
        this.setState({
          engine_car2: IMAGE_THUMB_URL+photo.car_upload_filename,
          engine_car_id2: photo.car_upload_id
        })
      }
      else if(photo.car_upload_position === 'console_car2'){
        this.setState({
          console_car2: IMAGE_THUMB_URL+photo.car_upload_filename,
          console_car_id2: photo.car_upload_id
        })
      }
      else if(photo.car_upload_position === 'plate_car2'){
        this.setState({
          plate_car2: IMAGE_THUMB_URL+photo.car_upload_filename,
          plate_car_id2: photo.car_upload_id
        })
      }
      else if(photo.car_upload_position === 'other_car2'){
        this.setState({
          other_car2: IMAGE_THUMB_URL+photo.car_upload_filename,
          other_car_id2: photo.car_upload_id
        })
      }

    });
  }


  handleUploadFile (event){


    var input_file_name = event.target.name
    var that = this;

    const data = new FormData();

    data.append('uploads', event.target.files[0], event.target.files[0].name)

    data.append('upload_code', this.props.upload_code);
    data.append('user_updated', this.state.user.user);

    // data.append('car_upload_position', input_file_name);
    // console.log(data)
    // alert(this.state.upload_code)

    if( input_file_name === 'front_car'){
      this.refs.img_front_car.src='img/loading.gif'
      this.refs.img_front_car.height=32
      data.append('car_upload_position', 'front_car');
      data.append('car_upload_id', this.state.front_car_id)
    }else if(input_file_name === 'front_right'){
      this.refs.img_front_right.src='img/loading.gif'
      data.append('car_upload_position', 'front_right');
      data.append('car_upload_id', this.state.front_right_id )
    }else if(input_file_name === 'front_left'){
      this.refs.img_front_left.src = 'img/loading.gif'
      data.append('car_upload_position', 'front_left');
      data.append('car_upload_id', this.state.front_left_id )
    }else if(input_file_name === 'side_car_left'){
      this.refs.img_side_car_left.src = 'img/loading.gif'
      data.append('car_upload_position', 'side_car_left');
      data.append('car_upload_id', this.state.side_car_left_id )
    }else if(input_file_name === 'side_car_right'){
      this.refs.img_side_car_right.src = 'img/loading.gif'
      data.append('car_upload_position', 'side_car_right');
      data.append('car_upload_id', this.state.side_car_right_id )
    }else if(input_file_name === 'back_straight'){
      this.refs.img_back_straight.src = 'img/loading.gif'
      data.append('car_upload_position', 'back_straight');
      data.append('car_upload_id', this.state.back_straight_id )
    }else if(input_file_name === 'console_car'){
      this.refs.img_console_car.src = 'img/loading.gif'
      data.append('car_upload_position', 'console_car');
      data.append('car_upload_id', this.state.console_car_id )
    }else if(input_file_name === 'condition_in_car'){
      this.refs.img_condition_in_car.src = 'img/loading.gif'
      data.append('car_upload_position', 'condition_in_car');
      data.append('car_upload_id', this.state.condition_in_car_id )
    }else if(input_file_name === 'engine_car'){
      this.refs.img_engine_car.src = 'img/loading.gif'
      data.append('car_upload_position', 'engine_car');
      data.append('car_upload_id', this.state.engine_car_id )
    }else if(input_file_name === 'plate_car'){
      this.refs.img_plate_car.src = 'img/loading.gif'
      data.append('car_upload_position', 'plate_car');
      data.append('car_upload_id', this.state.plate_car_id )
    }else if(input_file_name === 'other_car'){
      this.refs.img_other_car.src = 'img/loading.gif'
      data.append('car_upload_position', 'other_car');
      data.append('car_upload_id', this.state.other_car_id )
      // add เพิ่ม
    } else if (input_file_name === 'console') {
      // 12.คอนโซล
      this.refs.img_console.src = 'img/loading.gif'
      data.append('car_upload_position', 'console')
      data.append('car_upload_id', this.state.console_id )
    } else if (input_file_name === 'gear') {
      // 13.เกียร์
      this.refs.img_gear.src = 'img/loading.gif'
      data.append('car_upload_position', 'gear')
      data.append('car_upload_id', this.state.gear_id )
    } else if (input_file_name === 'audio_equipment') {
      // 14.เครื่องเสียง
      this.refs.img_audio_equipment.src = 'img/loading.gif'
      data.append('car_upload_position', 'audio_equipment')
      data.append('car_upload_id', this.state.audio_equipment_id )
    } else if (input_file_name === 'dial') {
      // 15) หน้าปัด
      this.refs.img_dial.src = 'img/loading.gif'
      data.append('car_upload_position', 'dial')
      data.append('car_upload_id', this.state.dial_id )
    }

    //alert(input_file_name)
    axios.put(APIURL+'/car_upload', data)
      .then(function(response){

        // console.log(response);

        var data = response.data ;
        var image_url = IMAGE_THUMB_URL+data.image;

        if(data.image === undefined) {
          image_url = IMAGE_UPLOAD_ERROR
        } else if (data.image === 'uploaderror') {
          image_url = IMAGE_UPLOAD_ERROR
        }

        ////console.log("image_url:"+image_url);
        var img = new Image();
        img.src= image_url;
        img.addEventListener("load", function () {

          if( input_file_name === 'front_car'){
            that.refs.img_front_car.src = image_url
          }else if(input_file_name === 'front_right'){
            that.refs.img_front_right.src= image_url
          }else if(input_file_name === 'front_left'){
            that.refs.img_front_left.src = image_url
          }else if(input_file_name === 'side_car_left'){
            that.refs.img_side_car_left.src = image_url
          }else if(input_file_name === 'side_car_right'){
            that.refs.img_side_car_right.src = image_url
          }else if(input_file_name === 'back_straight'){
            that.refs.img_back_straight.src = image_url
          }else if(input_file_name === 'console_car'){
            that.refs.img_console_car.src = image_url
          }else if(input_file_name === 'condition_in_car'){
            that.refs.img_condition_in_car.src = image_url
          }else if(input_file_name === 'engine_car'){
            that.refs.img_engine_car.src = image_url
          }else if(input_file_name === 'plate_car'){
            that.refs.img_plate_car.src = image_url
          }else if(input_file_name === 'other_car'){
            that.refs.img_other_car.src = image_url
            // add เพิ่ม
          } else if (input_file_name === 'console') {
            // 12
            that.refs.img_console.src = image_url
          } else if (input_file_name === 'gear') {
            // 13
            that.refs.img_gear.src = image_url
          } else if (input_file_name === 'audio_equipment') {
            // 14
            that.refs.img_audio_equipment.src = image_url
          } else if (input_file_name === 'dial') {
            // 15
            that.refs.img_dial.src = image_url
          }

        });

         // console.log(response);

      })
      .catch(function(error){
        console.log(error.response);
        // alert("error:"+error.response);
      });

  }

  handleUploadFile2 (event){


    var input_file_name = event.target.name
    var that = this;

    const data = new FormData();

    data.append('uploads', event.target.files[0], event.target.files[0].name)

    data.append('upload_code', this.props.upload_code);
    data.append('user_updated', this.state.user.user);

    // data.append('car_upload_position', input_file_name);
    // console.log(data)
    // alert(this.state.upload_code)

    if( input_file_name === 'front_car2'){
      this.refs.img_front_car2.src='img/loading.gif'
      this.refs.img_front_car2.height=32
      data.append('car_upload_position', 'front_car2');
      data.append('car_upload_id', this.state.front_car_id2)
    }else if(input_file_name === 'front_right2'){
      this.refs.img_front_right2.src='img/loading.gif'
      data.append('car_upload_position', 'front_right2');
      data.append('car_upload_id', this.state.front_right_id2 )
    }else if(input_file_name === 'front_left2'){
      this.refs.img_front_left2.src = 'img/loading.gif'
      data.append('car_upload_position', 'front_left2');
      data.append('car_upload_id', this.state.front_left_id2 )
    }else if(input_file_name === 'side_car_left2'){
      this.refs.img_side_car_left2.src = 'img/loading.gif'
      data.append('car_upload_position', 'side_car_left2');
      data.append('car_upload_id', this.state.side_car_left_id2 )
    }else if(input_file_name === 'side_car_right2'){
      this.refs.img_side_car_right2.src = 'img/loading.gif'
      data.append('car_upload_position', 'side_car_right2');
      data.append('car_upload_id', this.state.side_car_right_id2 )
    }else if(input_file_name === 'back_straight2'){
      this.refs.img_back_straight2.src = 'img/loading.gif'
      data.append('car_upload_position', 'back_straight2');
      data.append('car_upload_id', this.state.back_straight_id2 )
    }else if(input_file_name === 'console_car2'){
      this.refs.img_console_car2.src = 'img/loading.gif'
      data.append('car_upload_position', 'console_car2');
      data.append('car_upload_id', this.state.console_car_id2 )
    }else if(input_file_name === 'condition_in_car2'){
      this.refs.img_condition_in_car2.src = 'img/loading.gif'
      data.append('car_upload_position', 'condition_in_car2');
      data.append('car_upload_id', this.state.condition_in_car_id2 )
    }else if(input_file_name === 'engine_car2'){
      this.refs.img_engine_car2.src = 'img/loading.gif'
      data.append('car_upload_position', 'engine_car2');
      data.append('car_upload_id', this.state.engine_car_id2 )
    }else if(input_file_name === 'plate_car2'){
      this.refs.img_plate_car2.src = 'img/loading.gif'
      data.append('car_upload_position', 'plate_car2');
      data.append('car_upload_id', this.state.plate_car_id2 )
    }else if(input_file_name === 'other_car2'){
      this.refs.img_other_car2.src = 'img/loading.gif'
      data.append('car_upload_position', 'other_car2');
      data.append('car_upload_id', this.state.other_car_id2 )
    }

    //alert(input_file_name)
    axios.put(APIURL+'/car_upload', data)
      .then(function(response){
        var data = response.data ;
        var image_url = IMAGE_THUMB_URL+data.image;

        // console.log("response:", response);

        if(data.image === undefined) {
          image_url = IMAGE_UPLOAD_ERROR
        } else if (data.image === 'uploaderror') {
          image_url = IMAGE_UPLOAD_ERROR
        }

        var img = new Image();
        img.src= image_url;
        img.addEventListener("load", function () {

          if( input_file_name === 'front_car2'){
            that.refs.img_front_car2.src = image_url
          }else if(input_file_name === 'front_right2'){
            that.refs.img_front_right2.src= image_url
          }else if(input_file_name === 'front_left2'){
            that.refs.img_front_left2.src = image_url
          }else if(input_file_name === 'side_car_left2'){
            that.refs.img_side_car_left2.src = image_url
          }else if(input_file_name === 'side_car_right2'){
            that.refs.img_side_car_right2.src = image_url
          }else if(input_file_name === 'back_straight2'){
            that.refs.img_back_straight2.src = image_url
          }else if(input_file_name === 'console_car2'){
            that.refs.img_console_car2.src = image_url
          }else if(input_file_name === 'condition_in_car2'){
            that.refs.img_condition_in_car2.src = image_url
          }else if(input_file_name === 'engine_car2'){
            that.refs.img_engine_car2.src = image_url
          }else if(input_file_name === 'plate_car2'){
            that.refs.img_plate_car2.src = image_url
          }else if(input_file_name === 'other_car2'){
            that.refs.img_other_car2.src = image_url
          }

        });

         // console.log(response);
      })
      .catch(function(error){
         console.log(error.response);
        // alert("error:"+error.response);
      });

  }

  saveCarImage(e,urlImage){
    e.preventDefault();
    // console.log(e)
    // console.log(urlImage)
    let a = document.createElement('a');
    a.href = urlImage;
    a.target = '_blank';
    a.download = urlImage;
    a.click();
    a.remove();
    return false;
  }

  render(){
    return(
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <strong>รูปรถ</strong>
            </div>

            <div className="card-block">
      <div className="row">
        <div className="form-group col-sm-4">

          <label htmlFor="name">1) หน้าตรง
             &nbsp;<a rel="noopener noreferrer" href={this.state.front_car_full} target="_blank" onClick={(e)=>this.saveCarImage(e,this.state.front_car_full)} className={this.state.front_car_full===IMAGE_NOPHOTO_URL? 'hidden' : ''}><span>donwload</span></a>
          </label>
          <div style={styles.fileInputWrapper}  >
            <button style={styles.btnFileInput}>
              <img src={this.state.front_car}
                   style={styles.btnFileInputImage}
                   ref="img_front_car"
                   alt="หน้าตรง"
              />
            </button>
            <input
              style={styles.fileInput}
              type="file" name="front_car"
              onChange={this.handleUploadFile}
            />
          </div>

        </div>
        <div className="form-group col-sm-4">

          <label htmlFor="name">2) หน้าซ้าย
            &nbsp;<a rel="noopener noreferrer" href={this.state.front_right_full} target="_blank" onClick={(e)=>this.saveCarImage(e,this.state.front_right_full)} className={this.state.front_right_full===IMAGE_NOPHOTO_URL? 'hidden' : ''}><span>donwload</span></a>
          </label>
          <div style={styles.fileInputWrapper} >
            <button style={styles.btnFileInput}>
              <img src={this.state.front_right}
                   style={styles.btnFileInputImage}
                   ref="img_front_right"
                   alt="มุมขวา"
              />
            </button>
            <input
              style={styles.fileInput}
              type="file" name="front_right"
              onChange={this.handleUploadFile}
            />
          </div>

        </div>

        <div className="form-group col-sm-4">
          <label htmlFor="name">3) หน้าขวา
            &nbsp;<a rel="noopener noreferrer" href={this.state.front_left_full} target="_blank" onClick={(e)=>this.saveCarImage(e,this.state.front_left_full)} className={this.state.front_left_full===IMAGE_NOPHOTO_URL? 'hidden' : ''}><span>donwload</span></a>
          </label>
          <div style={styles.fileInputWrapper} >
            <button style={styles.btnFileInput}>
              <img src={this.state.front_left}
                   style={styles.btnFileInputImage}
                   ref="img_front_left"
                   alt="มุมซ้าย"
              />
            </button>
            <input
              style={styles.fileInput}
              type="file" name="front_left"
              onChange={this.handleUploadFile}
            />
          </div>
        </div>

        <div className="form-group col-sm-4">
          <label htmlFor="name">4) หลังตรง
            &nbsp;<a rel="noopener noreferrer" href={this.state.side_car_left_full} target="_blank" onClick={(e)=>this.saveCarImage(e,this.state.side_car_left_full)} className={this.state.side_car_left_full===IMAGE_NOPHOTO_URL? 'hidden' : ''}><span>donwload</span></a>
          </label>
          <div style={styles.fileInputWrapper} >
            <button style={styles.btnFileInput}>
              <img src={this.state.side_car_left}
                   style={styles.btnFileInputImage}
                   ref="img_side_car_left"
                   alt="ด้านซ้าย"
              />
            </button>
            <input
              style={styles.fileInput}
              type="file" name="side_car_left"
              onChange={this.handleUploadFile}
            />
          </div>
        </div>

        <div className="form-group col-sm-4">
          <label htmlFor="name">5) หลังซ้าย
            &nbsp;<a rel="noopener noreferrer" href={this.state.side_car_right_full} target="_blank" onClick={(e)=>this.saveCarImage(e,this.state.side_car_right_full)} className={this.state.side_car_right_full===IMAGE_NOPHOTO_URL? 'hidden' : ''}><span>donwload</span></a>
          </label>
          <div style={styles.fileInputWrapper} >
            <button style={styles.btnFileInput}>
              <img src={this.state.side_car_right}
                   style={styles.btnFileInputImage}
                   ref="img_side_car_right"
                   alt="ด้านขวา"
              />
            </button>
            <input
              style={styles.fileInput}
              type="file" name="side_car_right"
              onChange={this.handleUploadFile}
            />
          </div>
        </div>

        <div className="form-group col-sm-4">
          <label htmlFor="name">6) หลังขวา
            &nbsp;<a rel="noopener noreferrer" href={this.state.back_straight_full} target="_blank" onClick={(e)=>this.saveCarImage(e,this.state.back_straight_full)} className={this.state.back_straight_full===IMAGE_NOPHOTO_URL? 'hidden' : ''}><span>donwload</span></a>
          </label>
          <div style={styles.fileInputWrapper} >
            <button style={styles.btnFileInput}>
              <img src={this.state.back_straight}
                   style={styles.btnFileInputImage}
                   ref="img_back_straight"
                   alt="มุมตรง"
              />
            </button>
            <input
              style={styles.fileInput}
              type="file" name="back_straight"
              onChange={this.handleUploadFile}
            />
          </div>
        </div>

        <div className="form-group col-sm-4">
          <label htmlFor="name">7) ซ้ายตรง
            &nbsp;<a rel="noopener noreferrer" href={this.state.console_car_full} target="_blank" onClick={(e)=>this.saveCarImage(e,this.state.console_car_full)} className={this.state.console_car_full===IMAGE_NOPHOTO_URL? 'hidden' : ''}><span>donwload</span></a>
          </label>
          <div style={styles.fileInputWrapper} >
            <button style={styles.btnFileInput}>
              <img src={this.state.console_car}
                   style={styles.btnFileInputImage}
                   ref="img_console_car"
                   alt="คอนโซลรถ"
              />
            </button>
            <input
              style={styles.fileInput}
              type="file" name="console_car"
              onChange={this.handleUploadFile}
            />
          </div>
        </div>

        <div className="form-group col-sm-4">
          <label htmlFor="name">8) ขวาตรง
            &nbsp;<a rel="noopener noreferrer" href={this.state.condition_in_car_full} target="_blank" onClick={(e)=>this.saveCarImage(e,this.state.condition_in_car_full)} className={this.state.condition_in_car_full===IMAGE_NOPHOTO_URL? 'hidden' : ''}><span>donwload</span></a>
          </label>
          <div style={styles.fileInputWrapper} >
            <button style={styles.btnFileInput}>
              <img src={this.state.condition_in_car}
                   style={styles.btnFileInputImage}
                   ref="img_condition_in_car"
                   alt="สภาพภายในรถ"
              />
            </button>
            <input
              style={styles.fileInput}
              type="file" name="condition_in_car"
              onChange={this.handleUploadFile}
            />
          </div>
        </div>

        <div className="form-group col-sm-4">
          <label htmlFor="name">9) เครื่องยนต์
            &nbsp;<a rel="noopener noreferrer" href={this.state.engine_car_full} target="_blank" onClick={(e)=>this.saveCarImage(e,this.state.engine_car_full)} className={this.state.engine_car_full===IMAGE_NOPHOTO_URL? 'hidden' : ''}><span>donwload</span></a>
          </label>
          <div style={styles.fileInputWrapper} >
            <button style={styles.btnFileInput}>
              <img src={this.state.engine_car}
                   style={styles.btnFileInputImage}
                   ref="img_engine_car"
                   alt="เครื่องยนต์"
              />
            </button>
            <input
              style={styles.fileInput}
              type="file" name="engine_car"
              onChange={this.handleUploadFile}
            />
          </div>
        </div>

        <div className="form-group col-sm-4">
          <label htmlFor="name">10) เบาะหน้าขวา
            &nbsp;<a rel="noopener noreferrer" href={this.state.plate_car_full} target="_blank" onClick={(e)=>this.saveCarImage(e,this.state.plate_car_full)} className={this.state.plate_car_full===IMAGE_NOPHOTO_URL? 'hidden' : ''}><span>donwload</span></a>
          </label>
          <div style={styles.fileInputWrapper} >
            <button style={styles.btnFileInput}>
              <img src={this.state.plate_car}
                   style={styles.btnFileInputImage}
                   ref="img_plate_car"
                   alt="เพลทรถยนต์"
              />
            </button>
            <input
              style={styles.fileInput}
              type="file" name="plate_car"
              onChange={this.handleUploadFile}
            />
          </div>
        </div>

        <div className="form-group col-sm-4">
          <label htmlFor="name">11) เบาะหลังขวา
            &nbsp;<a rel="noopener noreferrer" href={this.state.other_car_full} target="_blank" onClick={(e)=>this.saveCarImage(e,this.state.other_car_full)} className={this.state.other_car_full===IMAGE_NOPHOTO_URL? 'hidden' : ''}><span>donwload</span></a>
          </label>
          <div style={styles.fileInputWrapper} >
            <button style={styles.btnFileInput}>
              <img src={this.state.other_car}
                   style={styles.btnFileInputImage}
                   ref="img_other_car"
                   alt="ภาพอื่นๆ"
              />
            </button>
            <input
              style={styles.fileInput}
              type="file" name="other_car"
              onChange={this.handleUploadFile}
            />
          </div>
        </div>

        <div className="form-group col-sm-4">
          <label htmlFor="name">12) คอนโซล
            &nbsp;<a rel="noopener noreferrer" href={this.state.console_full} target="_blank" onClick={(e)=>this.saveCarImage(e,this.state.console_full)} className={this.state.console_full===IMAGE_NOPHOTO_URL? 'hidden' : ''}><span>donwload</span></a>
          </label>
          <div style={styles.fileInputWrapper} >
            <button style={styles.btnFileInput}>
              <img src={this.state.console}
                   style={styles.btnFileInputImage}
                   ref="img_console"
                   alt="ภาพอื่นๆ"
              />
            </button>
            <input
              style={styles.fileInput}
              type="file" name="console"
              onChange={this.handleUploadFile}
            />
          </div>
        </div>

        <div className="form-group col-sm-4">
          <label htmlFor="name">13) เกียร์
            &nbsp;<a rel="noopener noreferrer" href={this.state.gear_full} target="_blank" onClick={(e)=>this.saveCarImage(e,this.state.gear_full)} className={this.state.gear_full===IMAGE_NOPHOTO_URL? 'hidden' : ''}><span>donwload</span></a>
          </label>
          <div style={styles.fileInputWrapper}>
            <button style={styles.btnFileInput}>
              <img src={this.state.gear}
                   style={styles.btnFileInputImage}
                   ref="img_gear"
                   alt="เกียร์"
              />
            </button>
            <input
              style={styles.fileInput}
              type="file" name="gear"
              onChange={this.handleUploadFile}
            />
          </div>
        </div>

        <div className="form-group col-sm-4">
          <label htmlFor="name">14) เครื่องเสียง
            &nbsp;<a rel="noopener noreferrer" href={this.state.audio_equipment_full} target="_blank" onClick={(e)=>this.saveCarImage(e,this.state.audio_equipment_full)} className={this.state.audio_equipment_full===IMAGE_NOPHOTO_URL? 'hidden' : ''}><span>donwload</span></a>
          </label>
          <div style={styles.fileInputWrapper}>
            <button style={styles.btnFileInput}>
              <img src={this.state.audio_equipment}
                   style={styles.btnFileInputImage}
                   ref="img_audio_equipment"
                   alt="เครื่องเสียง"
              />
            </button>
            <input
              style={styles.fileInput}
              type="file" name="audio_equipment"
              onChange={this.handleUploadFile}
            />
          </div>
        </div>

        <div className="form-group col-sm-4">
          <label htmlFor="name">15) หน้าปัด
            &nbsp;<a rel="noopener noreferrer" href={this.state.dial_full} target="_blank" onClick={(e)=>this.saveCarImage(e,this.state.dial_full)} className={this.state.dial_full===IMAGE_NOPHOTO_URL? 'hidden' : ''}><span>donwload</span></a>
          </label>
          <div style={styles.fileInputWrapper}>
            <button style={styles.btnFileInput}>
              <img src={this.state.dial}
                   style={styles.btnFileInputImage}
                   ref="img_dial"
                   alt="หน้าปัด"
              />
            </button>
            <input
              style={styles.fileInput}
              type="file" name="dial"
              onChange={this.handleUploadFile}
            />
          </div>
        </div>


      </div>
            </div>
          </div>
        </div>


        <div className={PORT === '9006' || PORT === '9000' ? "col-lg-12" : "hidden" } >
          <div className="card">
            <div className="card-header">
              <strong>รูปรถ(ก่อนแต่ง)</strong>
            </div>

            <div className="card-block">
              <div className="row">
                <div className="form-group col-sm-4">

                  <label htmlFor="name">1) หน้ารถ หน้าตรง (ก่อนแต่ง)</label>
                  <div style={styles.fileInputWrapper}  >
                    <button style={styles.btnFileInput}>
                      <img src={this.state.front_car2}
                           style={styles.btnFileInputImage}
                           ref="img_front_car2"
                           alt="หน้าตรง"
                      />
                    </button>
                    <input
                      style={styles.fileInput}
                      type="file" name="front_car2"
                      onChange={this.handleUploadFile2}
                    />
                  </div>

                </div>
                <div className="form-group col-sm-4">

                  <label htmlFor="name">2) หน้ารถ มุมขวา (ก่อนแต่ง)</label>
                  <div style={styles.fileInputWrapper} >
                    <button style={styles.btnFileInput}>
                      <img src={this.state.front_right2}
                           style={styles.btnFileInputImage}
                           ref="img_front_right2"
                           alt="มุมขวา"
                      />
                    </button>
                    <input
                      style={styles.fileInput}
                      type="file" name="front_right2"
                      onChange={this.handleUploadFile2}
                    />
                  </div>

                </div>

                <div className="form-group col-sm-4">
                  <label htmlFor="name">3) หน้ารถ มุมซ้าย (ก่อนแต่ง)</label>
                  <div style={styles.fileInputWrapper} >
                    <button style={styles.btnFileInput}>
                      <img src={this.state.front_left2}
                           style={styles.btnFileInputImage}
                           ref="img_front_left2"
                           alt="มุมซ้าย"
                      />
                    </button>
                    <input
                      style={styles.fileInput}
                      type="file" name="front_left2"
                      onChange={this.handleUploadFile2}
                    />
                  </div>
                </div>

                <div className="form-group col-sm-4">
                  <label htmlFor="name">4) ข้างรถ ด้านซ้าย (ก่อนแต่ง)</label>
                  <div style={styles.fileInputWrapper} >
                    <button style={styles.btnFileInput}>
                      <img src={this.state.side_car_left2}
                           style={styles.btnFileInputImage}
                           ref="img_side_car_left2"
                           alt="ด้านซ้าย"
                      />
                    </button>
                    <input
                      style={styles.fileInput}
                      type="file" name="side_car_left2"
                      onChange={this.handleUploadFile2}
                    />
                  </div>
                </div>

                <div className="form-group col-sm-4">
                  <label htmlFor="name">5) ข้างรถ ด้านขวา (ก่อนแต่ง)</label>
                  <div style={styles.fileInputWrapper} >
                    <button style={styles.btnFileInput}>
                      <img src={this.state.side_car_right2}
                           style={styles.btnFileInputImage}
                           ref="img_side_car_right2"
                           alt="ด้านขวา"
                      />
                    </button>
                    <input
                      style={styles.fileInput}
                      type="file" name="side_car_right2"
                      onChange={this.handleUploadFile2}
                    />
                  </div>
                </div>

                <div className="form-group col-sm-4">
                  <label htmlFor="name">6) หลังรถ มุมตรง (ก่อนแต่ง)</label>
                  <div style={styles.fileInputWrapper} >
                    <button style={styles.btnFileInput}>
                      <img src={this.state.back_straight2}
                           style={styles.btnFileInputImage}
                           ref="img_back_straight2"
                           alt="มุมตรง"
                      />
                    </button>
                    <input
                      style={styles.fileInput}
                      type="file" name="back_straight2"
                      onChange={this.handleUploadFile2}
                    />
                  </div>
                </div>

                <div className="form-group col-sm-4">
                  <label htmlFor="name">7) คอนโซลรถ (ก่อนแต่ง)</label>
                  <div style={styles.fileInputWrapper} >
                    <button style={styles.btnFileInput}>
                      <img src={this.state.console_car2}
                           style={styles.btnFileInputImage}
                           ref="img_console_car2"
                           alt="คอนโซลรถ"
                      />
                    </button>
                    <input
                      style={styles.fileInput}
                      type="file" name="console_car2"
                      onChange={this.handleUploadFile2}
                    />
                  </div>
                </div>

                <div className="form-group col-sm-4">
                  <label htmlFor="name">8) สภาพภายในรถ (ก่อนแต่ง)</label>
                  <div style={styles.fileInputWrapper} >
                    <button style={styles.btnFileInput}>
                      <img src={this.state.condition_in_car2}
                           style={styles.btnFileInputImage}
                           ref="img_condition_in_car2"
                           alt="สภาพภายในรถ"
                      />
                    </button>
                    <input
                      style={styles.fileInput}
                      type="file" name="condition_in_car2"
                      onChange={this.handleUploadFile2}
                    />
                  </div>
                </div>

                <div className="form-group col-sm-4">
                  <label htmlFor="name">9) เครื่องยนต์ (ก่อนแต่ง)</label>
                  <div style={styles.fileInputWrapper} >
                    <button style={styles.btnFileInput}>
                      <img src={this.state.engine_car2}
                           style={styles.btnFileInputImage}
                           ref="img_engine_car2"
                           alt="เครื่องยนต์"
                      />
                    </button>
                    <input
                      style={styles.fileInput}
                      type="file" name="engine_car2"
                      onChange={this.handleUploadFile2}
                    />
                  </div>
                </div>

                <div className="form-group col-sm-4">
                  <label htmlFor="name">10) เพลทรถยนต์ (ก่อนแต่ง)</label>
                  <div style={styles.fileInputWrapper} >
                    <button style={styles.btnFileInput}>
                      <img src={this.state.plate_car2}
                           style={styles.btnFileInputImage}
                           ref="img_plate_car2"
                           alt="เพลทรถยนต์"
                      />
                    </button>
                    <input
                      style={styles.fileInput}
                      type="file" name="plate_car2"
                      onChange={this.handleUploadFile2}
                    />
                  </div>
                </div>

                <div className="form-group col-sm-4">
                  <label htmlFor="name">11) ภาพอื่นๆ (ก่อนแต่ง)</label>
                  <div style={styles.fileInputWrapper} >
                    <button style={styles.btnFileInput}>
                      <img src={this.state.other_car2}
                           style={styles.btnFileInputImage}
                           ref="img_other_car2"
                           alt="ภาพอื่นๆ"
                      />
                    </button>
                    <input
                      style={styles.fileInput}
                      type="file" name="other_car2"
                      onChange={this.handleUploadFile2}
                    />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    )
  }
}


const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated
})

export default connect(mapStateToProps)(CarEditAlbum);

const styles = {
  fileInputWrapper: {
    position: 'relative',
    overflow: 'hidden',
    height: 120,
    width: 200,
  },
  btnFileInput: {
    height: 120,
    width: 200,
    display: 'inline-block',
    backgroundColor: "#D2DDE2",
    backgroundImage: "linear-gradient(to bottom, #D2DDE2, #FCF8FF)",
    backgroundRepeat: "repeat-x",

    color: "#ffffff",
    textShadow: "0 -1px 0 rgba(0, 0, 0, 0.25)"
  },
  btnFileInputImage:{
    position: 'absolute',
    top: 0,
    left: 0,
    height: 120,
    width: 200,
  },
  fileInput: {
    position: 'absolute',
    top: 0,
    right: 0,
    opacity: 0,
    height: 120,
    width: 200,
    cursor: 'pointer'
  }
}
